// src/components/MapUpdater.js
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const MapUpdater = ({ center, zoom }) => {
  const map = useMap();

  useEffect(() => {
    if (center) {
      // Update map center and zoom when center prop changes.
      map.setView(center, zoom);
      // Alternatively, use map.flyTo(center, zoom) for animated transitions.
    }
  }, [center, zoom, map]);

  return null;
};

export default MapUpdater;
